namespace Marhaba {

    class MarhabaAirports {
        constructor(
            private searchUnitService: any,
            private $location: ng.ILocationService,
            private $route: ng.route.IRouteService
        ) { }

        setMarhabaAirport(a) {
            this.searchUnitService.setMarhabaAirport(a);
            if (this.$route.current) {
                this.$location.path(this.$route.current.area);
            }
        }
    }

    angular
        .module('marhaba')
        .controller('MarhabaAirports', MarhabaAirports);
}
